export function MI (title: string, icon: string, link: string) {
    return {
        link,
        title,
        icon
    }
}

export function MIParent (title: string, icon: string, children: any[]) {
    return {
        link: '',
        title,
        icon,
        children
    }
}